// REACT
import { useHistory } from "react-router-dom";

// MATERIAL UI
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Stack, Typography } from "@mui/material";

// STYLES
import { TEXT_SECONDARY } from "./styles";

interface BackLinkProps {
  to: string;
  label?: string;
}

const BackLink = ({ to, label = "Back to Tax Center" }: BackLinkProps) => {
  const history = useHistory();

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={0.75}
      role="link"
      tabIndex={0}
      onClick={() => history.push(to)}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          history.push(to);
        }
      }}
      sx={{
        alignSelf: "flex-start",
        cursor: "pointer",
        color: TEXT_SECONDARY,
        "&:hover": { color: "#002035" },
      }}>
      <ArrowBackIcon sx={{ fontSize: 16 }} />
      <Typography sx={{ fontSize: 13, fontWeight: 500, color: "inherit" }}>{label}</Typography>
    </Stack>
  );
};

export default BackLink;
